/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {ServerModule, platformDynamicServer, platformServer} from './server';
export {__platform_server_private__} from './private_export';
export {VERSION} from './version';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
